import { SVGProps } from 'react'
import cx from 'classnames'

const DecoLineSVG = ({
  className,
  color = '#34E8F2',
  ...props
}: SVGProps<any>) => (
  <svg
    width="250"
    height="8"
    viewBox="0 0 250 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cx('tb-icon-deco-line', className)}
    {...props}>
    <path opacity="0.1" d="M4.71698 0H50L45.283 8H0L4.71698 0Z" fill={color} />
    <path opacity="0.2" d="M54.717 0H100L95.283 8H50L54.717 0Z" fill={color} />
    <path
      opacity="0.4"
      d="M104.717 0H150L145.283 8H100L104.717 0Z"
      fill={color}
    />
    <path
      opacity="0.6"
      d="M154.717 0H200L195.283 8H150L154.717 0Z"
      fill={color}
    />
    <path
      opacity="0.8"
      d="M204.717 0H250L245.283 8H200L204.717 0Z"
      fill={color}
    />
  </svg>
)

export default DecoLineSVG
